export const MAX_INPUT_LENGTH = 10000;
